import React from 'react'
import Typography from '@material-ui/core/Typography';
import useStyles from './style';
import { headerValue } from '../../utils/formatters';


const CardInfoViewer = (props) => {
    const { data, blockState } = props
    const classes = useStyles();
    return (
        <div className={classes.cardInfoContainer}>
            {
                data?.map((item, index) => (
                    <div key={index} className={classes.cardItem}>
                        <img src={item.icon} alt={item.label} className={classes.cardIcon} />
                        <div className={classes.cardContentWrapper}>
                            <Typography className={classes.cardLabel}>{item.label}</Typography>
                            <Typography className={classes.cardValue}>{headerValue(blockState, item.value, item)}</Typography>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default CardInfoViewer